export default "__VITE_ASSET__Bf8AX0lY__"